import React from 'react'
import { useSelector } from 'react-redux'
import { LinearProgress, useTheme } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import Gear from '../../assets/gear.png'
import GearBlack from '../../assets/gear-black.png'
import GearBlue from '../../assets/gear-blue.png'
import GearGray from '../../assets/gear-gray.png'
import ComBotBLue from '../../assets/combot-blue.svg'
import ComBotWhite from '../../assets/combot-white.svg'
import ComBotBlack from '../../assets/combot-black.svg'
import './spinner.css'
import config from '../../config'
import { progressBarStyles } from '../../utils'

const ROBO_SPINNER_COLORS = {
  [config.THEMES_MODES.LIGHT]: {
    overlayFallback: 'rgb(255,255,255)',
    overlay: 'rgba(255,255,255,0.7)',
  },
  [config.THEMES_MODES.CONTRAST_LIGHT]: {
    overlayFallback: 'rgb(255,255,255)',
    overlay: 'rgba(255,255,255,0.7)',
  },
  [config.THEMES_MODES.CONTRAST_DARK]: {
    text: '#ffffff',
    overlayFallback: 'rgb(0,0,0)',
    overlay: 'rgba(0,0,0,0.7)',
  },
}

const RoboSpinner = ({ text, spinnerProgress = 0, handleCancelClick = () => {}, cancelButton = false }) => {
  const { t } = useTranslation()
  const { theme: { colors, bgColors } } = useTheme()
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isContrast = themeState !== config.THEMES_MODES.LIGHT
  const classes = progressBarStyles(bgColors, colors)()
  const { overlayFallback, overlay } = ROBO_SPINNER_COLORS[themeState]

  const roboSpinnerStyle = {
    '--robo-spinner-text': colors.colorBlue1000,
    '--robo-spinner-overlay-fallback': overlayFallback,
    '--robo-spinner-overlay': overlay,
    '--spinner-overlay-fallback': overlayFallback,
    '--spinner-overlay': overlay,
  }
  const botImage = themeState === config.THEMES_MODES.LIGHT ? ComBotBLue : themeState === config.THEMES_MODES.CONTRAST_LIGHT ? ComBotBlack : ComBotWhite
  const gearImg = themeState === config.THEMES_MODES.LIGHT ? Gear : themeState === config.THEMES_MODES.CONTRAST_LIGHT ? GearBlack : GearGray
  const gearBlueImg = themeState === config.THEMES_MODES.LIGHT ? GearBlue : themeState === config.THEMES_MODES.CONTRAST_LIGHT ? GearBlack : GearGray

  return (
    <div className="modal-spinner" style={roboSpinnerStyle}>
      <div className="lds-css">
        <div className="gear-black"><img src={gearImg} width="30px" alt=""/></div>
        <div className="gear-blue"><img src={gearBlueImg} width="30px" alt=""/></div>
        <div className="gear-gray"><img src={GearGray} width="30px" alt=""/></div>
        <div className="bot"><img src={botImage} width="100px" alt=""/></div>
        <div className="text">
          <div>{text}</div>
          {spinnerProgress > 0 && <div><LinearProgress {...(!isContrast ? { color: "primary" } : {classes:{root: classes.root, bar: classes.bar}})} variant="determinate" value={spinnerProgress}/></div>}
        </div>
        {cancelButton &&
          <div className="cancel_div">
            <div>
              <button className="cancel_button" onClick={handleCancelClick}>{t('robospinner_cancel_button')}</button>
            </div>
          </div>}
      </div>
    </div>
  )
}

export default RoboSpinner
